/**
 * All business-editable values for the Limit Simulator app
 * Edit this file to change limits, bet sizes, ranges, and other business rules
 */

const BUSINESS_CONFIG = {
  slotMachine: {
    betSizes: [5, 10, 25, 50, 100],
    defaultBetIndex: 1, // index in betSizes array
    symbols: ['🍒', '🍋', '🔔', '🍊', '⭐', '🍉', '💎'],
    numReels: 3,
    spinDuration: 2000, // ms
    leverDownDuration: 300, // ms, time to pull lever down
    leverUpDuration: 300,   // ms, time to return lever up
    leverSpinTriggerOffset: 200, // ms after lever starts returning up to trigger reels
    winProbability: 0.5, // 50% chance of winning
    winMultiplier: 1,    // Win amount equals bet amount
  },
  limits: {
    netDeposit: { min: 700, max: 2000, step: 50, default: 700 },
    deposit: {
      daily: { min: 10, max: 500, step: 10, default: 100 },
      weekly: { min: 10, max: 1500, step: 50, default: 300 },
      monthly: { min: 10, max: 3000, step: 100, default: 1000 },
    },
    login: {
      daily: { min: 1, max: 8, step: 1, default: 8 },
      weekly: { min: 1, max: 56, step: 1, default: 40 },
      monthly: { min: 1, max: 240, step: 5, default: 160 },
    },
    withdrawal: {
      maxBalance: { min: 100, max: 2000, step: 50, default: 500 },
      reserve: { min: 0, max: 2000, step: 10, default: 100 },
    }
  },
  depositSlider: { min: 0, max: 300, step: 10 },
  withdrawSlider: { min: 0, max: 300, step: 10 },
};

export default BUSINESS_CONFIG; 